import React, { useEffect, useState } from "react";
import poster1 from "../../Assets/Posters/A.jpg";
import poster2 from "../../Assets/Posters/B.jpg";
import poster3 from "../../Assets/Posters/C.jpg";
import poster4 from "../../Assets/Banner/Welcome-back-school-1.jpg";
import poster5 from "../../Assets/Banner/Welcome-back-school-2.jpg";
import "./PosterView.css";
import { createPortal } from "react-dom";

const PosterView = () => {
    const images = [
        { id: 5, image: poster5, alt: "Banner 5" },
        { id: 1, image: poster1, alt: "Banner 1" },
        { id: 2, image: poster2, alt: "Banner 2" },
        { id: 3, image: poster3, alt: "Banner 3" },
        // { id: 4, image: poster4, alt: "Banner 4" },
    ];

    const [activeIndex, setActiveIndex] = useState(null);
    const [showWelcomePopup, setShowWelcomePopup] = useState(false);
    useEffect(() => {
        const seen = sessionStorage.getItem("welcomePopup");

        console.log(seen, "seen2")
        if (!seen) {
            console.log(seen, "seen")
            setShowWelcomePopup(true);
            sessionStorage.setItem("welcomePopup", "true");
        }
    }, []);

    const nextImage = () => {
        setActiveIndex((prev) => (prev + 1) % images.length);
    };

    const prevImage = () => {
        setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (activeIndex === null) return;

            if (e.key === "Escape") setActiveIndex(null);
            if (e.key === "ArrowRight") nextImage();
            if (e.key === "ArrowLeft") prevImage();
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [activeIndex]);
    console.log(showWelcomePopup, "showWelcomePopup")

    return (
        <>
            <div className="poster-view">
                {images.map((item, index) => (
                    <div key={item.id} onClick={() => setActiveIndex(index)}>
                        <img src={item.image} alt={item.alt} />
                    </div>
                ))}
            </div>

            {showWelcomePopup &&
                createPortal(
                    <div
                        className="welcome-popup-overlay"
                        onClick={() => setShowWelcomePopup(false)}
                    >
                        <div
                            className="welcome-popup"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className="welcome-popup-close"
                                onClick={() => setShowWelcomePopup(false)}
                            >
                                ✕
                            </button>

                            <img
                                src={poster4}
                                alt="Welcome"
                            />
                        </div>
                    </div>,
                    document.body
                )}
            {activeIndex !== null &&
                createPortal(
                    <div className="lightbox" onClick={() => setActiveIndex(null)}>
                        <div
                            className="lightbox-content"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className="lightbox-close"
                                onClick={() => setActiveIndex(null)}
                            >
                                ✕
                            </button>

                            <button className="lightbox-prev" onClick={prevImage}>
                                ❮
                            </button>

                            <img
                                src={images[activeIndex].image}
                                alt={images[activeIndex].alt}
                            />

                            <button className="lightbox-next" onClick={nextImage}>
                                ❯
                            </button>
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
};

export default PosterView;